exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tree-transfers-options .list-group .list-group-item, #tree-transfers-options-collapsed .list-group .list-group-item {\n  background-color: rgba(218, 213, 213, 0.85);\n  color: #7E7979; }\n  #tree-transfers-options .list-group .list-group-item.active, #tree-transfers-options-collapsed .list-group .list-group-item.active {\n    background-color: rgba(218, 213, 213, 0.95);\n    color: black; }\n\n#tree-transfers-options .transfers-option, #tree-transfers-options-collapsed .transfers-option {\n  cursor: pointer; }\n\n#tree-transfers-options-collapsed {\n  display: none;\n  z-index: 999999999;\n  width: 16em; }\n  #tree-transfers-options-collapsed.display {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/navigation/options/transfers/transfer-option.component.scss
// module id = ../../../../../src/app/components/navigation/options/transfers/transfer-option.component.scss
// module chunks = main